var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBacLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 42,
    viewBox: "0 0 157 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6016 7.53321L45.4604 20.2299L41.231 30.6794H29.6016V7.53321Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4872 0.0203934L0 7.42153V19.8348L27.4872 8.00027V0.0203934Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4872 10.3023L0 22.1369V35.8751L27.4872 19.0832V10.3023Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0386 41.2512H38.0588V32.7935H28.8162L20.0386 41.2512Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4872 21.5614L0 38.3522V41.2512H16.9916L27.4872 31.1389V21.5614Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3445 19.8251V19.7177C86.5774 18.3713 88.7324 15.5689 88.7324 11.0442C88.7324 4.63306 84.3151 0.635607 75.5332 0.635607H59.1021V41.1695H75.749C85.9311 41.1695 90.1873 36.6331 90.1873 29.3608C90.1873 24.2435 87.8165 21.0642 83.3455 19.8251H83.3445ZM67.8292 8.28585H75.2089C78.6029 8.28585 80.0578 9.48197 80.0578 12.6602C80.0578 15.8384 78.6577 17.1322 75.4247 17.1322H67.8292V8.28692V8.28585ZM75.8553 33.7351H67.8282V23.8655H75.6395C79.5725 23.8655 81.0811 25.2667 81.0811 28.6607C81.0811 32.4853 79.4651 33.7351 75.8553 33.7351Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.057 0.635607H104.228L90.2271 41.1695H99.8164L102.127 33.2391H116.781L119.092 41.1695H129.22L115.057 0.635607ZM104.336 25.6436L108.376 11.798L109.507 7.54176H109.669L110.746 11.798L114.625 25.6436H104.335H104.336Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.515 33.6493C140.134 33.6493 137.511 30.8157 137.511 20.6873C137.511 11.098 140.027 8.13449 147.354 8.13449C150.371 8.13449 153.951 8.6735 156.052 9.48093V1.66963C153.736 0.75375 150.048 0 146.816 0C133.886 0 127.977 7.16492 127.977 20.6336C127.977 35.0719 133.995 41.86 146.224 41.86C149.779 41.86 153.659 40.9441 156.298 39.6513V31.8132C154.036 32.7828 150.48 33.6503 147.517 33.6503L147.515 33.6493Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacLogoWhite);
export default __webpack_public_path__ + "static/media/bac_logo_white.ce4d54948cb3739eb8fbb6e5e2ad8d7c.svg";
export { ForwardRef as ReactComponent };